<template>
  <div v-if="completed && total">

    <div class="progress_row">
        <div class="progress_bar_label">{{ label }} - {{ completed + '/' + total }}</div>
        <b-progress height="35px" :max="total" class="sts_blc_InPlan">
            <b-progress-bar :value="completed" class="sts_blc_Prgs"></b-progress-bar>
        </b-progress>
    </div>

  </div>
</template>

<script>
    export default {
      name: 'progressBar',
      props: ['label', 'completed', 'total'],
      data: () => {
        return {}
      }
    }
</script>

<style scoped>
	.progress_row {
		position: relative;
		width: 95%;
		margin-bottom: 14px!important;
	}
	.progress_row:last-child {
		margin-bottom: 0px;
	}
    .progress_bar_label {
        position: absolute;
        margin: auto;
        top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px;
        text-align: center;
        height: 22px;
        font-size: 14px;
        color: #fff;
    }
  .blue-bg {
    background: rgb(2, 70, 115);
  }
</style>



// WEBPACK FOOTER //
// src/app/course/components/ProgressBar.vue